if (!customElements.get('header-banner')) {
  customElements.define(
    'header-banner',
    class HeaderBanner extends HTMLElement {
      connectedCallback() {
        this.header = document.querySelector('.header');

        if (!this.header) return;

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.classList.add(this.CLASSES.top);
            } else {
              if (this.scrollDirection === 'down') {
                this.headerBannerTimeout;
              } else {
                clearTimeout(this.headerBannerTimeout);

                this.classList.remove(this.CLASSES.top);
              }
            }
          });
        });

        observer.observe(this.header);
      }

      constructor() {
        super();

        this.CLASSES = {
          visibleBody: 'header-banner-is-visible',
          collapsed: 'header-banner--is-collapsed',
          sticky: 'header-banner--is-sticky',
          absolute: 'header-banner--is-absolute',
          top: 'header-banner--on-top',
        };

        this.body = document.body;
        this.lastScrollY = 0;

        window.scrollY > this.announcementBarHeight ? this.removeAbsolutePosition() : this.setAbsolutePosition();

        window.addEventListener('scroll', this.handleScroll.bind(this));
      }

      handleScroll() {
        const scrollY = window.scrollY;
        let scrollDirection = scrollY > this.lastScrollY && scrollY > this.announcementBarHeight ? 'down' : 'up';

        scrollY > this.announcementBarHeight ? this.removeAbsolutePosition() : this.setAbsolutePosition();

        if (scrollY === document.body.offsetHeight - document.documentElement.clientHeight) {
          scrollDirection = 'up';
          return;
        }

        scrollDirection === 'up' ? this.showHeader() : this.hideHeader();

        this.lastScrollY = scrollY > 0 ? scrollY : 0;

        this.scrollDirection = scrollDirection;
      }

      hideHeader() {
        this.classList.add(this.CLASSES.collapsed);
        this.body.classList.remove(this.CLASSES.visibleBody);
      }

      showHeader() {
        this.classList.remove(this.CLASSES.collapsed);
        this.body.classList.add(this.CLASSES.visibleBody);
      }

      setAbsolutePosition() {
        this.classList.add(this.CLASSES.absolute);
        this.body.style.setProperty('--scroll-y-position', `${window.scrollY}px`);
      }

      removeAbsolutePosition() {
        this.classList.remove(this.CLASSES.absolute);
      }

      /**
       * @type {String | null}
       */
      get scrollDirection() {
        return this._scrollDirection || null;
      }

      set scrollDirection(val) {
        this._scrollDirection = val;
      }

      get headerBannerTimeout() {
        return setTimeout(() => {
          this.classList.remove(this.CLASSES.top);
        }, 300);
      }

      get announcementBarHeight() {
        return (
          parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height'), 0) * 16
        );
      }
    },
  );
}
